<template>
  <el-dialog
    title="商品批次"
    :visible.sync="visible"
    width="720px"
    append-to-body=""
    :close-on-press-escape="false"
    @close="handleClose">
    <el-form
      :inline="true"
      style="display:flex;justify-content: space-between;"
      @submit.native.prevent>
      <el-form-item>
      </el-form-item>
      <el-form-item>
        <ent-product-auto-select
          v-model="config.productId"
          :callback="() => {handleCurrentChange(1)}" />
        <el-input
          v-model="config.batchCode"
          placeholder="请输入产品批次号"
          clearable=""
          style="width: 200px;margin-left: 10px;"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
      ref="table"
      v-loading="loading"
      border
      row-key="batchId"
      :data="list"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55">
      </el-table-column>
      <el-table-column
        label="商品批次号"
        width="160"
        prop="batchCode">
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="productName">
        <template slot-scope="{row}">
          {{ row.productName }}<span v-if="row.productNameRemark">({{ row.productNameRemark }})</span>
        </template>
      </el-table-column>
      <el-table-column
        label="商品数量"
        width="100"
        prop="goodsCount">
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="100">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat('YYYY-MM-DD') }}
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
export default {
  name: 'AssociateBatchModal',
  components: { EntProductAutoSelect },
  props: {
    selected: {
      type: Array,
      default() {
        return []
      }
    },
    option: {
      type: Object,
      default() {
        return {
          vendorId: '',
          tradeType: '',
          productIds: null,
          batchCode: ''
        }
      }
    }
  },
  data() {
    return {
      inited: true,
      loading: false,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productId: null,
        productTypes: [1, 9]
      },
      list: [],
      total: 0,
      multipleSelection: []
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  watch: {
    'option.productIds'() {
      this.inited = true
      this.config.pageNum = 1
      this.$refs.table && this.$refs.table.clearSelection()
    },
    visible(val) {
      if (val) {
        if (this.inited) {
          this.inited = false
          this.$nextTick(() => {
            this.selected.forEach(item => {
              this.$refs.table.toggleRowSelection(item, true)
            })
            this.fetchList()
          })
        }
      }
    }
  },
  created() { },
  mounted() {
    // this.fetchList()
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() { },
    reset(ret) {
      console.log('reset', ret)
      if (!this.inited) {
        this.config.pageNum = 1
        this.total = 0
        this.list = []
        this.$refs.table.clearSelection()
        this.inited = true
      }
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('batch/getbatchs', {
        payload: {
          canAssociateInspectReport: this.userPermission.OPERATE ? null : 1,
          ...this.config,
          ...this.option
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    submit() {
      this.$emit('update:selection', this.multipleSelection)
      this.toggleModal(false)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val // 勾选放在multipleSelection数组中
    }
  }
}
</script>
<style lang="stylus" scoped></style>
